import { Container, Texture, TilingSprite } from "pixi.js";
import { AssetKeys } from "./Assets";

export class Canopy extends Container {
  private sprite: TilingSprite;
  private scrollX = 0;

  constructor(textures: Record<string, Texture>) {
    super();
    this.sprite = new TilingSprite({
      texture: textures[AssetKeys.BgFore],
      width: 100,
      height: 100,
    });
    this.addChild(this.sprite);
  }

  resize(width: number, height: number) {
    const tex = this.sprite.texture;
    const portrait = height > width * 1.25;
    const layerH = Math.min(height * (portrait ? 0.12 : 0.14), 220);
    const texScale = layerH / tex.height;
    this.sprite.tileScale.set(texScale);
    this.sprite.width = width;
    this.sprite.height = layerH;
    this.sprite.position.set(0, height - layerH);
  }

  update(dt: number, scrollSpeed: number) {
    this.scrollX += scrollSpeed * dt;
    this.sprite.tilePosition.x = -this.scrollX;
  }
}
